/* RESPONSIBLE TEAM: team-inbox */
export const MAX_CONDITIONS_PER_DESCRIPTOR = 100;
